import { spCandidateBanFormLocs } from './components/ban-form/ban-form.locs';
import { spCandidateBanSectionLocs } from './components/ban-section/ban-section.locs';
import { spCandidateBanWatchLocs } from './components/ban-watch/ban-watch.locs';
import { spCandidateSecurityViolationsLocs } from './components/exam-violations/exam-violations.locs';
import { photosSignaturesLocs } from './components/photos-signatures/photos-signatures.component.locs';
import { spRsiSsiViolationDetailsLocs } from './components/rsi-ssi/rsi-ssi.locs';
import { spCandidateSystemActivityLocs } from './components/system-activity/system-activity.locs';
import { spCandidateWatchFormLocs } from './components/watch-form/watch-form.locs';
import { spCandidateWatchSectionLocs } from './components/watch-section/watch-section.locs';

export const spCandidateSecurityModuleLocs = {
	...photosSignaturesLocs,
	...spCandidateBanWatchLocs,
	...spCandidateBanFormLocs,
	...spCandidateBanSectionLocs,
	...spCandidateWatchFormLocs,
	...spCandidateWatchSectionLocs,
	...spCandidateSecurityViolationsLocs,
	...spRsiSsiViolationDetailsLocs,
	...spCandidateSystemActivityLocs,
};
